"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearableInput = void 0;
var react_1 = __importStar(require("react"));
var compose_react_refs_1 = __importDefault(require("@seznam/compose-react-refs"));
var Input_1 = require("../Input");
var Box_1 = require("../Box");
var Clear_1 = require("../Clear");
var Cell_1 = require("../Cell");
var theme_1 = require("../theme");
var CLEARABLE_BUTTON_WITH_MARGINS = "".concat(parseFloat((0, theme_1.space)(4)) * 2 + parseFloat((0, theme_1.space)(6))).concat(theme_1.SPACE_SCALE_UNIT);
exports.ClearableInput = react_1.default.forwardRef(function (_a, forwardedRef) {
    var m = _a.m, mt = _a.mt, mr = _a.mr, mb = _a.mb, ml = _a.ml, minWidth = _a.minWidth, width = _a.width, flex = _a.flex, flexGrow = _a.flexGrow, flexShrink = _a.flexShrink, flexBasis = _a.flexBasis, 
    // Above are spatial props for wrapper, remainder
    // is split off into input
    _b = _a.value, 
    // Above are spatial props for wrapper, remainder
    // is split off into input
    value = _b === void 0 ? "" : _b, onChange = _a.onChange, onClear = _a.onClear, rest = __rest(_a, ["m", "mt", "mr", "mb", "ml", "minWidth", "width", "flex", "flexGrow", "flexShrink", "flexBasis", "value", "onChange", "onClear"]);
    var ref = (0, react_1.useRef)(null);
    var _c = __read((0, react_1.useState)(value), 2), controlledValue = _c[0], setValue = _c[1];
    var handleClick = (0, react_1.useCallback)(function () {
        setValue("");
        onClear && onClear();
        onChange && onChange("");
        if (ref.current)
            ref.current.focus();
    }, [onChange, onClear]);
    var handleChange = (0, react_1.useCallback)(function (_a) {
        var value = _a.currentTarget.value;
        setValue(value);
        onChange && onChange(value);
    }, [onChange]);
    return (react_1.default.createElement(Box_1.Box, __assign({ position: "relative" }, {
        m: m,
        mt: mt,
        mr: mr,
        mb: mb,
        ml: ml,
        minWidth: minWidth,
        width: width,
        flex: flex,
        flexGrow: flexGrow,
        flexShrink: flexShrink,
        flexBasis: flexBasis,
    }),
        react_1.default.createElement(Input_1.Input, __assign({}, rest, { ref: (0, compose_react_refs_1.default)(ref, forwardedRef), width: "100%", value: controlledValue, onChange: handleChange, px: 0, pl: Cell_1.CELL.px, pr: CLEARABLE_BUTTON_WITH_MARGINS })),
        controlledValue && (react_1.default.createElement(Clear_1.Clear, { onClick: handleClick, position: "absolute", top: "50%", right: 0, mx: 4, backgroundColor: "hint", borderRadius: "50%", type: "reset", style: { transform: "translateY(-50%)" } }))));
});
exports.ClearableInput.displayName = "ClearableInput";
//# sourceMappingURL=ClearableInput.js.map